import React, { useState, useEffect } from "react";
import "./EditPassword.css";
import api from "../../../axiosconfig.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const EditPassword = () => {
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [userEmail, setUserEmail] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  
const getEmail = async () => {
  try {
    const responseName = await api.post("/dataRequest", {
      request: "getUserEmail"
    });
    setUserEmail(responseName.data.email);
  } catch (error) {
    setUserEmail("");
  }
};


  useEffect(() => {
    // Fetch the user's email
    getEmail();
  }, []); // Run the effect once on mount

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };


  const handleChangePassword = async () => {
    if (!form.currentPassword) {
      toast.warning("Please enter your current password.", {
      });
      return;
    }

    if (!form.newPassword) {
      toast.warning("Please enter a new password.", {
      });
      return;
    }

    if (form.newPassword.length < 6) {
      toast.warning("New password must be at least 6 characters long.", {
       
      });
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      toast.error("New password and confirm password do not match.", {
       
      });
      return;
    }

    try {
      const response = await api.post("/profile", {
        request: "changePassword",
        oldPassword: form.currentPassword,
        newPassword: form.newPassword,
      });

      console.log("Password update response:", response.data);

      if (response.data.result === 1) {
        toast.success("Password updated successfully!", {
          
        });
        setForm({ currentPassword: "", newPassword: "", confirmPassword: "" }); // Clear the form
      } else {
        toast.error(response.data.message || "Failed to update password. Please check your current password.", {
          
        });
      }
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error("Failed to update password. Please try again later.", {
        
      });
    }
  };

  return (
<div className="profile-password-page">
  <div className="profile-password-container">
    <div className="profile-password-field-group">
      <label className="profile-password-label">Current Password</label>
      <div className="profile-input-icon-wrapper">
        <input
          type={showPassword.currentPassword ? "text" : "password"}
          name="currentPassword"
          placeholder="Enter current password"
          className="profile-password-input"
          value={form.currentPassword}
          onChange={handleChange}
        />
        <FontAwesomeIcon
         icon={showPassword.currentPassword ? faEye : faEyeSlash}
         onClick={() => togglePasswordVisibility("currentPassword")}
          className="eye-icon"
        />
      </div>
    </div>

    <div className="profile-password-field-group">
      <label className="profile-password-label">New Password</label>
      <div className="profile-input-icon-wrapper">
        <input
          type={showPassword.newPassword ? "text" : "password"}
          name="newPassword"
          placeholder="Enter new password"
          className="profile-password-input"
          value={form.newPassword}
          onChange={handleChange}
        />
        <FontAwesomeIcon
        icon={showPassword.newPassword ? faEye : faEyeSlash}
        onClick={() => togglePasswordVisibility("newPassword")}
          className="eye-icon"
        />
      </div>
    </div>

    <div className="profile-password-field-group">
      <label className="profile-password-label">Confirm Password</label>
      <div className="profile-input-icon-wrapper">
        <input
          type={showPassword.confirmPassword ? "text" : "password"}
          name="confirmPassword"
          placeholder="Re-enter new password"
          className="profile-password-input"
          value={form.confirmPassword}
          onChange={handleChange}
        />
        <FontAwesomeIcon
        icon={showPassword.confirmPassword ? faEye : faEyeSlash}
        onClick={() => togglePasswordVisibility("confirmPassword")}
          className="eye-icon"
        />
      </div>
    </div>

    <div className="profile-password-field-group">
      <label className="profile-password-label">User Email:</label>
      {userEmail}
    </div>

    <button
      className="profile-password-update-btn"
      onClick={handleChangePassword}
    >
      Update Password
    </button>
  </div>
</div>
  );
};
